import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

const urlWorpress = environment.urlWordpress;

@Injectable({
  providedIn: 'root',
})
export class AdsService {
  constructor(private http: HttpClient) {}

  getBannerByCategory(data: string): Observable<any> {
    const category = data === 'home_banner' ? 28 : 29;
    return this.http.get(urlWorpress + `/banners?categories=${category}`);
  }
}
